import { Route, Routes } from "react-router-dom";
import Loader from "./components/layouts/loading/loading";
import React, { Suspense } from "react";
import "./styles/style.css";
import { useSelector } from "react-redux";
import Companies from "./pages/Companies";

// AddCovenantAccounting
const Login = React.lazy(() => import("./pages/auth/login"));
const Protected = React.lazy(() => import("./pages/auth/Protected"));
const Profile = React.lazy(() => import("./pages/Profile"));
const Admins = React.lazy(() => import("./pages/Admins"));
const IssueSetting = React.lazy(() =>
  import("./pages/IssueSetting/IssueSetting")
);
const AccountingSetting = React.lazy(() =>
  import("./pages/Accounting/AccountingSetting/AccountingSetting")
);

function App() {
  const { isAuthLoading } = useSelector((state) => state.AuthSlice);
  const { isSettingLoading } = useSelector((state) => state.SettingsSlice);
  const { isEmployeesLoading } = useSelector((state) => state.EmployeesSlice);
  const { isSharedLoading } = useSelector((state) => state.SharedSlice);

  return (
    <>
      {isAuthLoading && <Loader />}
      {isSettingLoading && <Loader />}
      {isEmployeesLoading && <Loader />}
      {isSharedLoading && <Loader />}

      <Suspense fallback={<Loader />}>
        <Routes>
          <Route element={<Protected />}>
            <Route path="/" element={<Profile />} />
            <Route path="*" element={<Profile />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/admins" element={<Admins />} />
            <Route path="/companies" element={<Companies />} />
            <Route path="/issue-setting" element={<IssueSetting />} />
            <Route path="/accounting-setting" element={<AccountingSetting />} />
            {/* Companies */}
          </Route>
          <Route path="/login" element={<Login />} />
        </Routes>
      </Suspense>
    </>
  );
}

export default App;
